import React from 'react'
import BannerMainImageSection from '../../../bannerMainImageSection'
import BannerBrandImageSection from '../../../bannerBrandImageSection'
import * as E from '../homeElements'
import { Row, Col } from 'react-bootstrap'
import { IOpportunityLostStageProps } from '../stages/interfaces/IOpportunityLostStageProps'

const OpportunityLostStage = (props: IOpportunityLostStageProps) => {
  const { firstName } = props

  return (
    <>
      <BannerMainImageSection></BannerMainImageSection>

      <BannerBrandImageSection id="maincontent">
        <E.ContainerBlock>
          <Row>
            <Col sm={12}>
              Not to worry {firstName}, one of our novated leasing consultants
              will be happy to help. Give them a call on 1300 328 182.
            </Col>
          </Row>
        </E.ContainerBlock>
      </BannerBrandImageSection>
    </>
  )
}

export default OpportunityLostStage
